/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const routes = {
    // public pages

    community: () => "/community",
    communityGuidelines: () => "/community-guidelines",
    contactUs: () => "/contact",
    faq: () => "/faq",
    home: () => "/",
    privacyPolicy: () => "/privacy-policy",
    termsOfService: () => "/terms-of-service",

    // webflow pages
    testimonials: () => "/testimonials",
    teacherSection: () => "/#teachers-section",
    about: () => "/about",
    careers: () => "/join-our-team",

    // redesign temp url
    diversity: () => "/diversity",

    // login & profile
    login: () => "/login",

    join: () => routes.home(),

    // member zone
    memberZone: () => "/member",
    memberHomePage: () => "/member/home",
    memberLegacyCommunityPage: () => "/member/community",
    memberSchedulePage: () => "/member/my-schedule",
    memberMembership: (stripeResult?: string) =>
        `/member/membership${stripeResult ? `?stripeResult=${stripeResult}` : ""}`,
    memberUpdateBilling: () => "/member/membership/updateBilling",
    memberSanghas: () => "/member/sanghas",
    memberSanghasDeprecated: () => "/member_dashboard_group",
    memberSanghaDetails: (sanghaId: string) => `/member/sanghas/${sanghaId}`,

    memberSessionsRightNow: () => "/member/sessions-right-now",
    memberDropInSessions: () => "/member/drop-in",
    memberDropInSessionsMonthlyTheme: () => "/member/drop-in/monthly-theme",
    memberDropInSessionsTalks: () => "/member/drop-in/talks",
    memberDropInSessionsMeditationsDiscussions: () => "/member/drop-in/meditations",
    memberDropInSessionsWelcomeSessions: () => "/member/drop-in/welcome-sessions",
    memberDropInSessionsAllSessions: () => "/member/drop-in/all-sessions",
    memberDropInSessionsSilentMeditations: () => "/member/drop-in/silent-meditations",

    editProfilePage: () => "/member/edit-profile",

    setupEditProfilePage: () => "/member/setup/edit-profile",
    setupWelcomeSession: () => "/member/setup/welcome-session",
    setupShowYouAround: () => "/member/setup/show-you-around",

    memberMindfulFriends: () => "/member/mindful-friends",

    conflictResolution: () => "/member/conflict-resolution",

    memberUpdateLegacyBillingPage1: () => "/member/legacy/updateBilling/page1",
    memberUpdateLegacyBillingPage2: () => "/member/legacy/updateBilling/page2",
    memberUpdateLegacyBillingPage3: () => "/member/legacy/updateBilling/page3",

    testInterestGroupGuidelines: () => "/member/test-mfg-guidelines",

    memberTeachersPage: () => "/member/teachers",
    publicTeachersPage: () => "/teachers",

    // donation flow
    memberContribute: () => "/member/contribute",
    memberDonate: () => "/member/donate",
    memberDonationSuccess: () => "/member/donate/success",

    memberOnboarding: () => "/member/onboarding",

    // donation flow for visitors
    visitorDonate: () => "/donate",
    visitorDonationSuccess: () => "/donate-success",

    // immersion cancellation flow
    cancelMembership: () => "/member/cancel",
    cancelMembershipPage1: () => "/member/cancel/page1",
    cancelMembershipReason: () => "/member/cancel/reason",
    cancelMembershipPage3: () => "/member/cancel/page3",
    cancelMembershipPage5: () => "/member/cancel/page5",
    cancelMembershipPage6: () => "/member/cancel/page6",
    cancelMembershipPage7: () => "/member/cancel/page7",
    cancelMembershipPage8: () => "/member/cancel/page8",

    // add mentorship group
    addMentorshipGroup: (sanghaId: string) => `/member/add-mentorship-group/${sanghaId}`,

    // add interest group
    allInterestGroups: () => "/mindful-friend-groups",
    addInterestGroup: (groupId: string) => `/mindful-friend-groups/group/${groupId}`,

    setupAllInterestGroups: () => `/member/setup/mindful-friend-groups`,
    setupAddInterestGroup: (groupId: string) =>
        `/member/setup/mindful-friend-groups/group/${groupId}`,
    setupConfirmInterestGroup: (groupId: string) =>
        `/member/setup/mindful-friend-groups/group/${groupId}/confirm`,

    memberAddInterestGroup: (groupId: string) => `/member/mindful-friend-groups/group/${groupId}`,
    memberConfirmInterestGroup: (groupId: string) =>
        `/member/mindful-friend-groups/group/${groupId}/confirm`,

    // signup flow
    signup: (preselectedBillingPlan?: string) =>
        `/signup${preselectedBillingPlan ? `?plan=${preselectedBillingPlan}` : ""}`,
    signupAccount: () => "/signup/account",
    signupCommitments: () => "/signup/commitments",
    signupBilling: () => "/signup/billing",
    signupSuccess: () => "/signup/success",

    // teacher zone
    teacherPostSession: (sanghaId: string) => `/teachers/post-session/${sanghaId}`,
    teacherPostSessionRecap: (sanghaId: string) => `/teachers/post-session/${sanghaId}/recap`,
    teacherPostSessionReflection: (sanghaId: string) =>
        `/teachers/post-session/${sanghaId}/reflection`,
    teacherPostSessionSuccess: (sanghaId: string) => `/teachers/post-session/${sanghaId}/success`,
};

export const getFullUrl = (path: string) => `${window.location.origin}${path}`;
